import React from "react";
import { FaBriefcase, FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";

const experiences = [
  {
    role: "Digital Systems Officer",
    company: "Bridge for Impact Hub (BIH)",
    date: "2026",
    location: "Accra (Remote)",
    bullets: [
      "Achieved continuous high availability of organisational systems by administering and optimising internal digital infrastructure and proactively resolving technical bottlenecks.",
      "Accelerated operational scale by collaborating with leadership to design and deploy practical technology solutions aligned with BIH's digital transformation roadmap.",
      "Maintained system performance through structured monitoring routines and delivered first-line technical support, reducing resolution time across the organisation."
    ]
  },
  {
    role: "IT Infrastructure Intern",
    company: "National Investment Bank PLC",
    date: "03/2025 - 11/2025",
    location: "Accra, Ghana",
    bullets: [
      "Assisted in configuring and maintaining network devices, printers, and workstations across departments while supporting installation and troubleshooting of core banking applications.",
      "Monitored server and network performance, reporting issues to senior IT staff, and performed hardware maintenance, software updates, and data backup checks to ensure system reliability.",
      "Documented support tickets and IT procedures to improve issue tracking, contributing to substantial improvements in IT support response time within an enterprise banking environment."
    ]
  },
  {
    role: "Media & IT Intern",
    company: "Stix Evolution",
    date: "06/2024 - 08/2024",
    location: "Accra, Ghana",
    bullets: [
      "Assisted in video editing, media content creation, digital asset management, and provided basic IT support ensuring smooth operation of media production software.",
      "Organized and maintained media storage systems, ensuring data security and accessibility."
    ]
  }
];

function Experience() {
  return (
    <section id="experience" className="experience">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Work Experience</h2>
          <p className="section-subtitle">
            Hands-on professional experience in enterprise infrastructure administration, systems optimization, and technical support.
          </p>
        </div>

        <div className="timeline">
          {experiences.map((exp, i) => (
            <div key={i} className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-card">
                <div className="timeline-header">
                  <div>
                    <h3 className="timeline-role">{exp.role}</h3>
                    <div className="timeline-company">
                      <FaBriefcase /> {exp.company}
                    </div>
                  </div>
                  <div className="timeline-meta">
                    <span className="timeline-date">
                      <FaCalendarAlt /> {exp.date}
                    </span>
                    {exp.location && (
                      <span className="timeline-date">
                        <FaMapMarkerAlt /> {exp.location}
                      </span>
                    )}
                  </div>
                </div>
                <ul className="timeline-bullets">
                  {exp.bullets.map((bullet, j) => (
                    <li key={j}>{bullet}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
